import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    chatId: null,
}

export const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setChatId: (state, action) => {
            state.chatId = action.payload;
        }     
    },
})

// Action creators are generated for each case reducer function
export const { setChatId, resetChatId } = chatSlice.actions

export default chatSlice.reducer